import { useCallback } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Typography } from '@altermaind/web/ui';
import { getEmployerByIdCall, postEmployerByIdDisableCall } from '@/people/state';
import { useNotification } from '../../hooks';
import { Dialog } from '../Dialog';

type Props = {
  isOpen: boolean;
  closeDialog: () => void;
  employeeId: string;
};

export const DisableProfile = ({ isOpen, closeDialog, employeeId }: Props) => {
  const t = useTranslations('profileCard.dialogs.disableProfile');
  const tShared = useTranslations();
  const { notify } = useNotification();
  const { execute: executePostEmployerByIdDisable, loading: loadingPostEmployerByIdDisable } =
    postEmployerByIdDisableCall.hook();

  const { execute: executeGetEmployerById } = getEmployerByIdCall.hook();

  const onConfirm = useCallback(() => {
    executePostEmployerByIdDisable({
      employeeId,
      successSaga: () => {
        notify(tShared('success.genericApiSuccess'), 'success');
        closeDialog();
        executeGetEmployerById({
          employeeId,
        });
      },
      errorSaga: () => {
        notify(tShared('errors.genericApiError'), 'error');
      },
    });
  }, [
    executePostEmployerByIdDisable,
    employeeId,
    notify,
    tShared,
    closeDialog,
    executeGetEmployerById,
  ]);

  return (
    <Dialog
      maxWidth='550px'
      name='disableProfile'
      open={isOpen}
      title={undefined}
      onClose={closeDialog}
      closeButton
    >
      <Box display='flex' flexDirection='column'>
        <Typography mt='none' variant='h3' color='primary/text' textAlign='center'>
          {t('title')}
        </Typography>
      </Box>

      <Box mb='xs' mt='m' width='100%'>
        <Typography variant='p2/light' mb='xs' color='primary/text' textAlign='center'>
          {t('description')}
        </Typography>
        <Typography variant='p2/light' fontWeight='bold' color='primary/text' textAlign='center'>
          {t('confirmation')}
        </Typography>
        <Box mt='s' alignItems='center' display='flex' flexDirection='row' justifyContent='center'>
          <Button variant='link/primary' onClick={() => closeDialog()} mr='s' mt='s'>
            {t('buttons.cancel')}
          </Button>
          <Button
            loading={loadingPostEmployerByIdDisable}
            disabled={loadingPostEmployerByIdDisable}
            mt='s'
            data-testid='button-disable-profile'
            onClick={onConfirm}
          >
            {t('buttons.confirm')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
